import {FONT_FAMILIES} from '../../../../../const';

const tabsStyles = {
  '& .MuiTabs-flexContainer': {
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0 auto'
  },
  '& .MuiTabs-scroller': {
    display: 'flex',
    height: '100%',
    zIndex: 9,
    background: 'inherit'
  },
  '& .MuiTabs-centered': {
    alignItems: 'center',
    justifyContent: 'center'
  },

  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3
  },

  // Hide indicator
  '& .MuiTabs-indicator': {
    display: 'none'
  },

  '& .MuiTab-root': {
    color: 'white !important',
    opacity: 0.5,
    fontFamily: FONT_FAMILIES.TITLE,
    fontSize: 13,
    textTransform: 'none',
    minWidth: 'auto',
    px: 2
  },

  '& .Mui-selected': {
    opacity: 1,
    fontWeight: 700
  },

  '& .MuiTabs-scrollButtons': {
    color: 'white !important',
    opacity: 1
  }
};

export default tabsStyles;
